import { useMemo } from 'react';
import { useAuth } from './useAuth';
import { useGlobalOrganization } from './useGlobalOrganization';
import { resolveOrganizationRole } from '@/lib/userRole';

export const useCurrentUser = () => {
  const { isAuthenticated, isLoading: isAuthLoading } = useAuth();
  const {
    organizations,
    selectedOrgId,
    isLoading: isOrganizationsLoading,
  } = useGlobalOrganization();

  const userRole = useMemo(() => {
    if (!isAuthenticated) {
      return null;
    }

    return resolveOrganizationRole(organizations, selectedOrgId);
  }, [isAuthenticated, organizations, selectedOrgId]);

  const requiresOrganizationSelection = isAuthenticated && organizations.length > 1 && !userRole;
  const isLoading = isAuthLoading || (isAuthenticated && (isOrganizationsLoading || requiresOrganizationSelection));

  const isAdmin = userRole === 'admin';

  return {
    userRole,
    isAdmin,
    isLoading
  };
};
